const body = document.querySelector('body')

export default {
  menuPortalTarget: body,
  menuPosition: 'fixed',
  styles: {
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
      maxHeight: 200,
    }),
  },
  useReactSelect: true,
}
